$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
Auth = require 'db/auth'
Camera = require 'views/camera/camera'
localizeServerError = require 'lib/localize-server-error'
PopOver = require 'views/lib/pop-over'
TakePhotoView = require 'views/camera/take-photo-view'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
dataUriToBlob = require 'lib/util/url/data-uri-to-blob'

module.exports = class ChangeAvatarPopoverView extends View
  viewTitleKey: 'change avatar'

  initialize: ->
    @listenTo @model, 'change:avatarSource change:uploadedAvatarHash',
      @frameDebounce @render

  events:
    'change .js-upload-avatar': 'startUpload'
    'click .js-use-gravatar': 'useGravatar'
    'click .js-use-uploaded-avatar': 'useUploadedAvatar'
    'click .js-take-photo': 'takePhoto'
    'click .js-no-avatar': 'clearAvatar'

  render: ->
    view = @

    data = @model.toJSON(prefs: true)
    data["avatarSource_#{ data.avatarSource }"] = true

    data.canTakePhoto = Camera.supportsGetUserMedia()

    @$el.html(
      templates.fill(
        'avatar_change',
        data
      )
    )

    gravSect = @$('.js-grav')
    $img = gravSect.find('img')

    # Adding a cache breaker so browers like safari don't cache 404 responses
    # from gravatar
    url = "https://secure.gravatar.com/avatar/" +
          "#{ @model.get('gravatarHash') }.png?s=50&r=PG&d=404" +
          "&_=#{ Math.random() }"
    Util.waitForImageLoad url
      .then -> gravSect.show()

    @

  startUpload: (e) ->
    model = @model
    input = $(e.target)
    file = input[0]?.files?[0]
    $error = @$('.js-error').hide()

    if file? && !Util.validFileSize(file)
      $error.text(l('images can not be larger than 10mb')).show()
      track("Member", "Avatar", "Upload Error - File Too Large")
      return

    track("Member", "Avatar", "Use Uploaded - New")

    if !file && input.val()
      # IE special-case
      return Util.uploadFile Auth.myToken(), input, @uploadResult.bind(@)

    if !file?
      # No file specified
      return

    # Ajax upload
    fd = new FormData()
    fd.append('token', Auth.myToken())
    fd.append('file', file)

    ApiAjax
      url: input.closest('form').attr('action')
      data: fd
      type: 'post'
      processData: false
      contentType: false
      error: (res) =>
        @uploadResult(new Error(localizeServerError(res)))
      success: => @uploadResult(null, arguments...)
      timeout: 120000

  uploadResult: (err) ->
    $error = @$('.js-error').hide()

    if (err)
      $error.show().text(err)

  useUploadedAvatar: (e) ->
    track("Member", "Avatar", "Use Uploaded - Existing")
    @model.update('avatarSource', 'upload')
    PopOver.popView()

  useGravatar: (e) ->
    track("Member", "Avatar", "Use Gravatar")
    @model.update('avatarSource', 'gravatar')
    PopOver.popView()

  clearAvatar: (e) ->
    track("Member", "Avatar", "Use Initials")
    @model.update('avatarSource', 'none')
    PopOver.popView()

  takePhoto: (e) ->
    savePhoto = (dataURI) =>
      blob = dataUriToBlob(dataURI)

      fd = new FormData()
      fd.append('token', Auth.myToken())
      fd.append('file', blob, 'avatar.png')

      ApiAjax
        url: "/1/member/#{ @model.id }/avatar"
        data: fd
        type: 'post'
        processData: false
        contentType: false
        error: ({ status, responseText }, textStatus, error, fxDefault) =>
          if status == 413
            #next("Error uploading #{ file.name ? name }")
          else
            # Default is to retry
            fxDefault()
        timeout: 60000

    PopOver.pushView
      view: new TakePhotoView({ @model, @modelCache, savePhoto })

    track("Member", "Avatar", "Take Photo")



// WEBPACK FOOTER //
// ./app/scripts/views/member/change-avatar-popover-view.coffee